module.exports = __webpack_public_path__ + "img/prism-background.57f15081.png";